import React from "react";
import "./Progressocial.css"; // Import the CSS

const Progressocial = ({ onClose }) => {
  return (
    <div className="floating-popup">
      <div className="popup-content">
        <button className="close-button" onClick={onClose}>
          <strong>x</strong>
        </button>
        <div className="modal-video" style={{ padding: "10px" }}>
        
          
          
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div>
              <img
                className="img-fluid"
                src="/assets/images/RSE/PacteMondiale.jpg"
                alt="PacteMondiale"
                style={{ maxHeight: "300px" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Progressocial;
